import { render, staticRenderFns } from "./PaymentAlert.vue?vue&type=template&id=369d01e5&scoped=true&"
import script from "./PaymentAlert.vue?vue&type=script&lang=ts&"
export * from "./PaymentAlert.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentAlert.vue?vue&type=style&index=0&id=369d01e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d01e5",
  null
  
)

export default component.exports